import { Instance, types } from 'mobx-state-tree';

export const OrderItem = types
  .model({
    name: types.string,
    partNumber: types.string,
    isPromotional: types.boolean,
    imageUrl: types.optional(types.string, ''),
    price: types.number,
    totalPrice: types.number,
    quantity: types.number,
    weight: types.optional(types.number, 0),
    totalWeight: types.optional(types.number, 0)
  })
  .named('OrderItem');

export type OrderItem = Instance<typeof OrderItem>;
